/*!

=========================================================
* Argon Design System React - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-design-system-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-design-system-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
import { Link } from "react-router-dom";
// nodejs library that concatenates classes
import classnames from "classnames";

// reactstrap components
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Form,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Container,
  Row,
  Col,
  Badge
} from "reactstrap";

class Login extends React.Component {
  state = {};
  render() {
    return (
      <>
        {/* Hero Section */}
        <section className="section section-lg section-shaped">
          <div className="shape shape-style-1 shape-primary">
            <span />
            <span />
            <span />
            <span />
            <span />
            <span />
            <span />
          </div>
          <Container className="py-lg-md d-flex">
            <div className="col px-0">
              <Row className="align-items-center justify-content-center">
                <Col className="text-center" lg="8">
                  <div className="icon icon-xl icon-shape bg-white shadow rounded-circle text-primary mb-4">
                    <i className="ni ni-settings-gear-65" />
                  </div>
                  <h1 className="display-2 text-white font-weight-bold">
                    Nos Services d'Excellence
                  </h1>
                  <p className="lead text-white opacity-8 mt-4">
                    Des solutions énergétiques sur mesure avec un service personnalisé 
                    qui dépasse vos attentes. Découvrez comment nous pouvons optimiser 
                    votre approvisionnement en gaz naturel.
                  </p>
                  <div className="btn-wrapper mt-5">
                    <Button
                      className="btn-white btn-icon mb-3 mb-sm-0"
                      color="default"
                      size="lg"
                      href="mailto:nvincent@nugaz.com?subject=Demande d'information - Services"
                    >
                      <span className="btn-inner--icon mr-2">
                        <i className="ni ni-email-83" />
                      </span>
                      <span className="btn-inner--text">Demander une soumission</span>
                  </Button>
            
                </div>
              </Col>
              </Row>
                </div>
          </Container>
          {/* SVG separator */}
          <div className="separator separator-bottom separator-skew">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              preserveAspectRatio="none"
              version="1.1"
              viewBox="0 0 2560 100"
              x="0"
              y="0"
            >
              <polygon className="fill-white" points="2560 0 2560 100 0 100" />
            </svg>
          </div>
        </section>

                {/* Main Services Section */}
        <section className="section section-lg">
          <Container>
            <Row className="justify-content-center">
              <Col lg="12">
                <Row className="row-grid">
                  <Col lg="4">
                    <Card className="card-lift--hover shadow border-0">
                      <CardBody className="py-5">
                        <div className="icon icon-shape bg-gradient-primary rounded-circle text-white mb-4">
                          <i className="ni ni-delivery-fast" />
                        </div>
                        <h6 className="text-primary text-uppercase font-weight-bold">
                          Approvisionnement Flexible
                        </h6>
                        <p className="description mt-3">
                          Approvisionnement selon les modes offerts par Énergir ou Gazifère. 
                          Solutions adaptées à vos besoins spécifiques avec une expertise reconnue.
                        </p>
                        <div>
                          <Badge color="primary" pill className="mr-1">
                            Énergir
                          </Badge>
                          <Badge color="primary" pill className="mr-1">
                            Gazifère
                          </Badge>
                        </div>
                      </CardBody>
                    </Card>
                  </Col>
                  
                  <Col lg="4">
                    <Card className="card-lift--hover shadow border-0">
                      <CardBody className="py-5">
                        <div className="icon icon-shape bg-gradient-success rounded-circle text-white mb-4">
                          <i className="ni ni-chart-bar-32" />
                        </div>
                        <h6 className="text-success text-uppercase font-weight-bold">
                          Information de Marché
                        </h6>
                        <p className="description mt-3">
                          Feuille de prix journalière pour information de marché et guidance 
                          experte pour vos choix d'approvisionnement selon vos objectifs.
                        </p>
                        <div>
                          <Badge color="success" pill className="mr-1">
                            Prix quotidiens
                          </Badge>
                          <Badge color="success" pill className="mr-1">
                            Analyse
                          </Badge>
                        </div>
                      </CardBody>
                    </Card>
                  </Col>
                  
                  <Col lg="4">
                    <Card className="card-lift--hover shadow border-0">
                      <CardBody className="py-5">
                        <div className="icon icon-shape bg-gradient-warning rounded-circle text-white mb-4">
                          <i className="ni ni-money-coins" />
                        </div>
                        <h6 className="text-warning text-uppercase font-weight-bold">
                          Options de Tarification
                        </h6>
                        <p className="description mt-3">
                          Fourniture de gaz naturel à prix fixe, variable ou hybride 
                          (partiellement fixe et variable) selon votre stratégie énergétique.
                        </p>
                        <div>
                          <Badge color="warning" pill className="mr-1">
                            Prix fixe
                          </Badge>
                          <Badge color="warning" pill className="mr-1">
                            Variable
                          </Badge>
                          <Badge color="warning" pill className="mr-1">
                            Hybride
                          </Badge>
                        </div>
                      </CardBody>
                    </Card>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Container>
        </section>

        {/* Additional Services Section */}
        <section className="section bg-gradient-info">
          <Container>
            <Row className="justify-content-center text-center mb-5">
              <Col lg="8">
                <h2 className="display-3 text-white font-weight-bold">Services Complémentaires</h2>
                <p className="lead text-white opacity-8">
                  Une approche globale pour simplifier votre gestion énergétique
                </p>
              </Col>
            </Row>
            
            <Row className="row-grid">
              <Col lg="6">
                <Card className="bg-white shadow border-0">
                  <CardBody className="p-5">
                    <div className="d-flex">
                      <div className="icon icon-shape bg-gradient-info rounded-circle text-white">
                        <i className="ni ni-support-16" />
                      </div>
                      <div className="pl-4">
                        <h5 className="title text-info font-weight-bold">Support Local Expert</h5>
                        <p className="description">
                          Équipe locale pour communication rapide et efficace. 
                          Facturation, contrat et toute communication en français ou anglais 
                          selon vos préférences.
                        </p>
                        <div className="mt-3">
                          <Badge color="info" pill className="mr-1">
                            Français
                          </Badge>
                          <Badge color="info" pill className="mr-1">
                            English
                          </Badge>
                        </div>
                      </div>
                    </div>
                  </CardBody>
                </Card>
                </Col>
              
              <Col lg="6">
                <Card className="bg-white shadow border-0">
                  <CardBody className="p-5">
                    <div className="d-flex">
                      <div className="icon icon-shape bg-gradient-success rounded-circle text-white">
                        <i className="ni ni-briefcase-24" />
                      </div>
                    <div className="pl-4">
                        <h5 className="title text-success font-weight-bold">Gestion Simplifiée</h5>
                        <p className="description">
                          Mandataire auprès du distributeur pour faciliter votre gestion. 
                          Nous prenons en charge les aspects administratifs pour que vous puissiez 
                          vous concentrer sur votre activité principale.
                        </p>
                        <div className="mt-3">
                          <Badge color="success" pill className="mr-1">
                            Gestion administrative
                          </Badge>
                        </div>
                      </div>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </section>

        {/* Call to Action Section */}
        <section className="section section-lg">
          <Container>
            <Row className="justify-content-center text-center">
              <Col lg="8">
                <Card className="bg-gradient-warning shadow-lg border-0">
                  <CardBody className="p-5">
                    <div className="icon icon-xl icon-shape bg-white shadow rounded-circle text-warning mb-4">
                      <i className="ni ni-diamond" />
                    </div>
                    <h2 className="display-3 text-white font-weight-bold">
                      Prêt à optimiser vos coûts énergétiques ?
                    </h2>
                    <p className="lead text-white opacity-8 mt-4">
                      Contactez nos experts dès aujourd'hui pour une analyse personnalisée 
                      de vos besoins énergétiques et découvrez comment nous pouvons vous aider 
                      à réaliser des économies significatives.
                    </p>
                    <div className="btn-wrapper mt-5">
                      <Button
                        className="btn-white btn-icon"
                        color="default"
                        size="lg"
                        href="mailto:nvincent@nugaz.com?subject=Demande de consultation - Services énergétiques"
                      >
                        <span className="btn-inner--icon mr-2">
                          <i className="ni ni-email-83" />
                        </span>
                        <span className="btn-inner--text">Consultation gratuite</span>
                      </Button>
                      <Button
                        className="btn-outline-white btn-icon ml-3"
                        color="default"
                        size="lg"
                        to="/contact-page"
                        tag={Link}
                      >
                        <span className="btn-inner--icon mr-2">
                          <i className="ni ni-circle-08" />
                        </span>
                        <span className="btn-inner--text">Rencontrer l'équipe</span>
                      </Button>
                  </div>
                  </CardBody>
                </Card>
                </Col>
              </Row>
            </Container>
          </section>

        {/* Coverage Information Section */}
        <section className="section pb-0 bg-gradient-white">
            <Container>
              <Row className="row-grid align-items-center">
                <Col className="order-lg-2 ml-lg-auto" md="6">
                <div className="position-relative pl-md-5">
                  <img
                    alt="Couverture du Québec - Solution Nügaz"
                    className="img-center img-fluid"
                    src={require("assets/img/ill/ill-2.svg").default}
                  />
                </div>
                </Col>
                <Col className="order-lg-1" lg="6">
                <div className="d-flex px-3">
                  <div>
                    <div className="icon icon-lg icon-shape bg-gradient-primary shadow rounded-circle text-white">
                      <i className="ni ni-world-2 text-white" />
                    </div>
                  </div>
                  <div className="pl-4">
                    <h2 className="display-3 text-black font-weight-bold mb-4">
                      Notre Portée au Québec
                    </h2>
                    <Card className="shadow-sm border-0 mb-4">
                      <CardBody className="p-4">
                        <h5 className="text-primary font-weight-bold mb-3">
                          <i className="ni ni-chart-bar-32 mr-2"></i>Couverture Provinciale
                        </h5>
                        <p className="text-muted">
                          Solution Nügaz développe tout le marché du Québec pour les consommateurs 
                          de <strong>7 500 à 3 500 000 m³/année</strong>, offrant des solutions 
                          adaptées à toutes les tailles d'entreprise.
                        </p>
                        <div className="mt-3">
                          <Badge color="primary" pill className="mr-2">
                            Petites entreprises
                          </Badge>
                          <Badge color="primary" pill className="mr-2">
                            Industries
                          </Badge>
                          <Badge color="primary" pill className="mr-2">
                            Institutions
                          </Badge>
                        </div>
                      </CardBody>
                    </Card>
                    
                    <Card className="bg-gradient-success shadow-lg border-0">
                      <CardBody className="p-4">
                        <h6 className="text-white font-weight-bold mb-2">
                          <i className="ni ni-trophy mr-2"></i>Partenariat de Confiance
                        </h6>
                        <p className="text-white opacity-8 mb-0">
                          Grâce à notre partenariat avec Emera Energy L.P., nous garantissons 
                          un approvisionnement fiable et des prix compétitifs pour tous nos clients.
                        </p>
                      </CardBody>
                    </Card>
                  </div>
                </div>
                </Col>
              </Row>
            </Container>
          {/* SVG separator */}
          <div className="separator separator-bottom separator-skew zindex-100">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              preserveAspectRatio="none"
              version="1.1"
              viewBox="0 0 2560 100"
              x="0"
              y="0"
            >
              <polygon
                className="fill-white" 
                points="2560 0 2560 100 0 100"
              />
            </svg>
          </div>
          </section>
      </>
    );
  }
}

export default Login;